import React from 'react'
import { SelectLabelMultiProps } from './interface'
import classNames from 'classnames'
import { defaultClearIcon, defaultDropIcon } from './SelectLabel'

const Multi = <V extends unknown[] = [],>(props: SelectLabelMultiProps<V>) => {
  const {
    value,
    data = [],
    placeholder = '请选择',
    customText,
    clearIcon,
    onChange,
    dropIcon,
    className,
    style,
    open,
    disabled,
  } = props

  return (
    <span
      className={classNames(className, 'zySelectLabelWrap')}
      style={style}
      data-open={open}
      data-active={(value ?? undefined) !== undefined}
      data-clearable={clearIcon !== false && !!value?.length}
      data-disabled={disabled}
    >
      <span className="zySelectLabel">
        <span className="zySelectLabelText">
          {customText?.(value, data) || placeholder}
        </span>
        {!!value?.length && (
          <span className="zySelectLabelLength">{value.length}</span>
        )}
        {dropIcon !== false &&
          (dropIcon === true || dropIcon === undefined
            ? defaultDropIcon
            : dropIcon)}
        {clearIcon !== false && !!value?.length && (
          <span
            className="zySelectLabelClear"
            onClick={(ev) => onChange?.({ value: undefined, event: ev })}
          >
            {clearIcon === true || clearIcon === undefined
              ? defaultClearIcon
              : clearIcon}
          </span>
        )}
      </span>
    </span>
  )
}

export default Multi
